import { useMemo } from "react";
import { Layout } from "../components/ColumnLayout";
import useResizeObserver from "./useResizeObserver";

function useColumnLayout<T>(layouts: Layout[], items: T[]) {
  const size = useResizeObserver();

  const columns = useMemo(() => {
    let windowWidth = 0;
    size.forEach(({ contentRect }) => (windowWidth = contentRect.width));

    let layout: Layout | undefined = undefined;
    for (const element of layouts) {
      if (windowWidth > element.threshold) {
        if (layout === undefined || element.threshold > layout.threshold) {
          layout = element;
        }
      }
    }

    if (layout) {
      const _columns = items.reduce(
        (prev, curr, i) => {
          const index = i % layout!.columns;
          if (prev[index]) {
            prev[index] = [...prev[index], curr];
          } else {
            prev[index] = [curr];
          }
          return prev;
        },
        new Array(layout.columns).fill([]) as T[][],
      );

      return _columns;
    }
    return [];
  }, [items, layouts, size]);

  return columns;
}

export default useColumnLayout;
